// src/models/User.js
export default class User {
    constructor({
      fullName,
      email,
      phoneNumber,
      role,
      officeId,
      gender,
      profilePicture = '',
      signature = ''
    }) {
      this.fullName = fullName;
      this.email = email;
      this.phoneNumber = phoneNumber;
      this.role = role;
      this.officeId = officeId;
      this.gender = gender;
      this.profilePicture = profilePicture;
      this.signature = signature;
      this.createdAt = new Date(); // Timestamp when the user is created
      this.lastAccessed = new Date(); // Last access timestamp
    }
  
    // Method to convert the User instance to a plain object for Firebase
    toFirestore() {
      return {
        fullName: this.fullName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        role: this.role,
        officeId: this.officeId,
        gender: this.gender,
        profilePicture: this.profilePicture,
        signature: this.signature,
        createdAt: this.createdAt,
        lastAccessed: this.lastAccessed
      };
    }
  }
  